export const holidaysPerYearTotal = 28
export const sickDaysPerYearTotal = 5

export const homeOfficePerMonthTotal = 5

export const taxRate = 1.21
